// it will get the degrees or angle of the point
export const angle = (from, to) => {
	const dy = to.y - from.y;
	const dx = to.x - from.x;
	let theta = Math.atan2(dy, dx); // range (-PI, PI]
	theta *= 180 / Math.PI; // rads to degs, range (-180, 180]
	//if (theta < 0) theta = 360 + theta; // range [0, 360)
	return theta;
};

//to  get the lenth of to points
export const pythagorasTheorem = (from, to) => {
	const xDist = from.x - to.x;
	const yDist = from.y - to.y;

	return Math.sqrt(xDist * xDist + yDist * yDist);
};